import { ServerConfig } from "@/config/config";
import { Axios } from "./auth-service";

class PeppolServiceClass {
	public readonly url:string = `${ServerConfig.mainAppHost}/peppol`;

	public async sendEUSR(month:number, year:number):Promise<string>{
		let result = await Axios.post(`${this.url}/send-eusr`, {Month: month+1, Year: year});
		return result.data;
	}

	public async sendTSR(month:number, year:number):Promise<string>{
		let result = await Axios.post(`${this.url}/send-tsr`, {Month: month+1, Year: year});
		return result.data;
	}
}

export const PeppolService = new PeppolServiceClass();